import { styled } from '@mui/system';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

const Container = styled('div')({
  width: '100%',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px 16px'
});

const Text = styled(Typography)({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontStyle: 'normal',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '28px',
  color: '#565F6F'
});

interface NoPatientCardProps {
  searching: boolean;
}

export default function NoPatientCard({ searching }: NoPatientCardProps) {
  return (
    <Container>
      <Avatar sx={{ width: 56, height: 56 }} />
      <Text>{searching ? 'No Patients Found' : 'Enter a Name or Phone'}</Text>
    </Container>
  );
}
